module.exports = __webpack_public_path__ + "static/DifficultyDifficultGames2-ff6aa84386df18b7f33b2de6b35b8d07.webp";